import { Icon } from '@chakra-ui/react';

export const CustomMeatballIcon = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      class="c-hdkwsG c-hdkwsG-dvzWZT-size-medium c-hdkwsG-OzWqL-weight-normal"
    >
      <path
        fill="currentColor"
        d="M6 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2ZM14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2ZM22 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Z"
      ></path>
    </svg>
  </Icon>
);
